import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from '../api/api';
import { jwtDecode } from 'jwt-decode';
import Layout from '../components/Layout';

const Login = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();

    const handleLogin = async (e) => {
        e.preventDefault();
        try {
            // Gửi yêu cầu đăng nhập
            const response = await axios.post('/users/login', { username, password });
            const token = response.data.token;

            // Lưu token vào localStorage
            localStorage.setItem('token', token);

            // Giải mã token để lấy thông tin userId và username
            const decoded = jwtDecode(token);
            localStorage.setItem('userId', decoded.id);
            localStorage.setItem('username', decoded.username);
            localStorage.setItem('avatar', decoded.avatar);

            // Chuyển hướng người dùng sau khi đăng nhập thành công
            navigate('/'); // Điều hướng tới trang dashboard
        } catch (err) {
            setError('Đăng nhập không thành công. Vui lòng kiểm tra lại thông tin.');
        }
    };

    return (
        <Layout>
            <div className="container mt-5"     style={{ backgroundColor: 'white', minHeight: '100vh', padding: '20px'}}>
                <h2>Đăng Nhập</h2>
                <form onSubmit={handleLogin}>
                    <div className="mb-3">
                        <label htmlFor="username" className="form-label">Tên đăng nhập</label>
                        <input
                            type="text"
                            id="username"
                            className="form-control"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            required
                        />
                    </div>
                    <div className="mb-3">
                        <label htmlFor="password" className="form-label">Mật khẩu</label>
                        <input
                            type="password"
                            id="password"
                            className="form-control"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                        />
                    </div>
                    {error && <p className="text-danger">{error}</p>}
                    <button type="submit" className="btn btn-primary">Đăng Nhập</button>
                </form>
                <p className="mt-3">
                    <a href="/forgot-password">Quên mật khẩu?</a>
                </p>
                <p className="mt-2">
                    Chưa có tài khoản?{' '}
                    <a href="/register" className="text-primary">Đăng ký ngay</a>
                </p>
            </div>
        </Layout>
    );
};

export default Login;
